module.exports = __webpack_public_path__ + "static/media/trial2_4.3b5abbe0.png";